<template>
  <div class="">
    <b-form-checkbox
      v-model="checkbox"
      inline
      v-if="!isMultiple"
      @input="onChange"
      :id="uniqueId"
      :disabled="isFieldDisabled"
    />
    <div class="" v-else>
      <div class="d-flex" v-for="(check, index) in checkOptions" :key="uniqueId+index+'ccheck'">
        <div class="mr-1">{{ check.name }}</div>
        <b-form-checkbox
          v-model="checkboxMultiple[check.name]"
          @input="onChange(true, check.name)"
          :disabled="isFieldDisabled"
        />
      </div>
    </div>
    <div class="d-flex flex-column">
      <span class="text-error" v-if="error">{{ error }}</span>
    </div>
  </div>
</template>
<script>
import {ref, onMounted, computed, watch} from "@vue/composition-api";
export default {
  components: {
  },
  props: {
    field: {
      type: Object,
      default: () => ({}),
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const uniqueId = Date.now().toString(36) + Math.random().toString(36).slice(2);
    const isFieldDisabled = ref(false);
    const checkbox = ref(false);
    const checkboxMultiple = ref([]);
    const error = ref(null);
    const isMultiple = props?.field?.options?.fieldTypeCfg?.data?.length > 1
    const checkOptions = props?.field?.options?.fieldTypeCfg?.data || []

    watch(
      () => props.errors,
      (newValue, oldValue) => {
        error.value = props.errors[props.field.originalName] || null;
      },
      { immediate: true }
    );

    watch(
      () => props.isFormDisabled,
      (newValue, oldValue) => {
        isFieldDisabled.value = props.isFormDisabled;
      },
      { immediate: true }
    );

    onMounted(async () => {
      isFieldDisabled.value = props.isFormDisabled
    });

    function onChange() {
      let value = checkbox.value;
      if(isMultiple) {
        value = Object.keys(checkboxMultiple.value).filter(
          key => checkboxMultiple.value[key]
        )
      }
      emit("updateData", props.field, value);
    }

    return {
      uniqueId,
      isFieldDisabled,
      checkbox,
      checkboxMultiple,
      isMultiple,
      checkOptions,
      error,
      onChange,
    }
  }
}
</script>
<style scoped lang="scss">
.text-error {
  color: #ec0303;
}
.timeNoBackground {
  border-radius: 0.3em;
  background-color: transparent;
  margin: 0;
  border-radius: 0.3em;
  border: 1px solid #cecece;
  padding: 0.75em;
  margin: 0;
  background-color: #fff;
}
</style>